import type {
  ChatAgentConversationDeleteApiData,
  ChatAgentConversationDeleteApiResponses,
  ChatAgentConversationGetApiData,
  ChatAgentConversationGetApiResponses,
  ChatAgentConversationRenameApiData,
  ChatAgentConversationRenameApiResponses,
  ChatAgentConversationsListApiData,
  ChatAgentConversationsListApiResponses,
  ChatAgentFeedbackApiData,
  ChatAgentFeedbackApiResponses,
  ChatAgentSessionFeedbackDeleteApiData,
  ChatAgentSessionFeedbackDeleteApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getChatAgentUrls = {
  postChatAgentFeedback: responseEndpoint<ChatAgentFeedbackApiData, ChatAgentFeedbackApiResponses>({
    getUrl: () => apiUrl('communication/chat-agent/feedback/'),
    getBody: (data) => data
  }),
  deleteChatAgentFeedback: dataEndpoint<
    ChatAgentSessionFeedbackDeleteApiData,
    ChatAgentSessionFeedbackDeleteApiResponses
  >({
    getUrl: ({ sessionId }) => apiUrl(`communication/chat-agent/feedback/${encodeURIComponent(sessionId)}/`)
  }),
  getChatAgentConversations: dataEndpoint<ChatAgentConversationsListApiData, ChatAgentConversationsListApiResponses>({
    getUrl: (queryParams) => apiUrl('communication/chat-agent/conversations/', queryParams)
  }),
  getChatAgentConversation: dataEndpoint<ChatAgentConversationGetApiData, ChatAgentConversationGetApiResponses>({
    getUrl: ({ conversationUid }) => apiUrl(`communication/chat-agent/conversations/${conversationUid}/`)
  }),
  patchChatAgentConversation: responseEndpoint<
    ChatAgentConversationRenameApiData,
    ChatAgentConversationRenameApiResponses
  >({
    getUrl: ({ conversationUid }) => apiUrl(`communication/chat-agent/conversations/${conversationUid}/`),
    getBody: ({ title }) => ({ title })
  }),
  deleteChatAgentConversation: dataEndpoint<
    ChatAgentConversationDeleteApiData,
    ChatAgentConversationDeleteApiResponses
  >({
    getUrl: ({ conversationUid }) => apiUrl(`communication/chat-agent/conversations/${conversationUid}/`)
  })
};
